export enum ScreenType {
  Question = 'question',
  Result = 'result'
}
